// extracted by mini-css-extract-plugin
export default {"mCard":"SA-z","image":"TA-z","imageNoBackground":"UA-z","imageHasCategory":"VA-z","fullWidth":"WA-z"};